import React, { useEffect } from 'react'
import { Outlet, useLocation, useSearchParams, useNavigate } from "react-router-dom";
import { token } from 'modules/token';
import { EnvironmentVariables } from 'models/environment';
import env from 'modules/env/env';
import './layout.css';

export const Layout: React.FC = () => {
  const navigate = useNavigate();

  function useQuery() {
    return new URLSearchParams(useLocation().search);
  }

  let isLoading = true;
  const language = env(EnvironmentVariables.countryCode);
  const [searchParams, setSearchParams] = useSearchParams();
  let query = useQuery();
  let code = query.get("code");
  let scope = query.get("scope");

  useEffect(() => {
    let accessToken = window.sessionStorage.getItem('access_token');

    if (isLoading && code && scope && !accessToken) {
      isLoading = false;
      window.sessionStorage.setItem('scope', scope);
      token.getTokenByCode(scope, code)
        .then((response) => {
          window.sessionStorage.setItem('access_token', response.data.access_token);
          window.sessionStorage.setItem('refresh_token', response.data.refresh_token);
          query.delete('code');
          query.delete('scope');
          setSearchParams(query.toString());
        }).catch((error) => {
          console.log(error.config);
          navigate('/error');
        }) ;
    }
  }, [code, scope, isLoading]);

  return (
    <>
      <div className="App container" style={language == 'in' ? { fontFamily: 'Poppins' }: {}}>
        <Outlet />
      </div>
    </>
  )
};